'use client';

import React from 'react';
import CountingVotesReport from './CountingVotesReport';
import ExportReport from './ExportReport';
import VotesReports from './VotesReports';
import Fieldset from '~/components/commonUi/Fieldset';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import StandVotesList from './StandVotesList';
import StandVotesReports from './StandVotesReports';

interface Props {
    title: string | undefined;
    userVoteFromStand: number;
    userVoteFromWeb: number;
    isShowedUserVoteList: boolean;
    setIsShowedUserVoteList: (isShowed: boolean) => void;
}

const RegionReports = (props: Props) => {
    const { title, userVoteFromStand, userVoteFromWeb, isShowedUserVoteList, setIsShowedUserVoteList } = props;

    return (
        <div className="region-reports mb-4">
            <div className="overflow-x-auto">
                <Fieldset title={title}>
                    {isShowedUserVoteList ? (
                        <StandVotesReports />
                    ) : (
                        <VotesReports
                            reportLink={true}
                            userVoteFromStand={userVoteFromStand}
                            userVoteFromWeb={userVoteFromWeb}
                            setIsShowedUserVoteList={setIsShowedUserVoteList}
                        />
                    )}
                </Fieldset>
            </div>
            {isShowedUserVoteList ? <StandVotesList /> : <CountingVotesReport />}
            <ExportReport />
        </div>
    );
};

const RegionReportsWithStore = () => {
    const { reportStore, electionMenuStore } = getStore();

    return (
        <RegionReports
            title={`${electionMenuStore.selectedElectionMenu?.text} - Rapport`}
            userVoteFromStand={reportStore?.userCount?.stand}
            userVoteFromWeb={reportStore?.userCount?.web}
            isShowedUserVoteList={reportStore.isShowedUserVoteList}
            setIsShowedUserVoteList={reportStore.setIsShowedUserVoteList}
        />
    );
};

export default observer(RegionReportsWithStore);
